import { useEffect, useRef } from 'react';
import {
  computeVariableScrollFromScale,
  computeHorizontalScrollFromScale,
} from '../utils/pdfScrollMath';

export const usePdfScrollSync = ({
  listRef,
  pdfScale,
  getScrollMetrics,
  getPageHeights,
  getPageWidth,
  gap,
}) => {
  const prevScaleRef = useRef(pdfScale);

  useEffect(() => {
    const list = listRef.current;
    const container = list?._outerRef;
    const scrollMetrics = getScrollMetrics ? getScrollMetrics() : null;
    const pageHeights =
      scrollMetrics?.pageHeights ||
      (getPageHeights ? getPageHeights() : []);
    const pageWidth =
      scrollMetrics?.maxPageWidth ||
      scrollMetrics?.pageWidth ||
      (getPageWidth ? getPageWidth() : 0);

    if (!list || !container || !pageHeights?.length || !pageWidth) return;

    const prevScale = prevScaleRef.current;
    const nextScale = pdfScale;

    if (prevScale === nextScale) return;

    const scrollTop = list.state.scrollOffset;

    const { targetScroll } = computeVariableScrollFromScale({
      scrollTop,
      pageHeights,
      prevScale,
      nextScale,
      gap,
    });

    /* ---------- HORIZONTAL SCROLL ---------- */
    const containerWidth = container.clientWidth;
    const scrollLeftBefore = container.scrollLeft;
    const nextScrollLeft = computeHorizontalScrollFromScale({
      pageWidth,
      containerWidth,
      prevScale,
      nextScale,
      scrollLeftBefore,
    });

    list.resetAfterIndex?.(0, false);

    list.scrollTo(targetScroll);
    container.scrollLeft = nextScrollLeft;

    // list.resetAfterIndex(0, false);

    // requestAnimationFrame(() => {
    //   list.scrollTo(targetScroll);
    // });

    prevScaleRef.current = nextScale;
  }, [pdfScale, gap, getScrollMetrics, getPageHeights, getPageWidth]);
};
